import Rails from "@rails/ujs"
import Layout from "../layout"
import Page from "../components/page"
import Newsletter from "../components/newsletter"
import Menu from "../components/menu"
import UserMenu from "../components/user-menu.js"
import Cart from "../components/cart"
import Package from "../components/package"
// import Product from "../components/product.js"
import PhotoEditor from "../components/photo-editor.js"
import FotobookEditor from "../components/fotobook_editor.js"
import FotobookPhotoSelector from "../components/fotobook_photo_selector.js"
import FotobookMenu from "../components/fotobook_menu.js"
import CoverSelector from "../components/cover_selector.js"
import Alert from "../admin/alert"

class App extends Layout {
    constructor() {
        super()
        Rails.start()
        window["CART"] = new Cart()
        this.menu = new Menu()
        this.userMenu = new UserMenu()
        this.package = new Package()
        if (document.getElementById('fotobook-selection-section')) {
            this.fotobookEditor = new FotobookEditor()
            // Hacer la instancia disponible globalmente para acceso desde otros componentes
            window.fotobookEditor = this.fotobookEditor
            window.fotobookPhotoSelector = new FotobookPhotoSelector()
            this.fotobookMenu = new FotobookMenu()
            // Hacer CoverSelector disponible globalmente
            window.coverSelector = new CoverSelector()
            // this.fotobookAccordion = new FotobookAccordion() // Ya no se usa, ahora es solo menú de secciones
        } else {
            this.editor = new PhotoEditor()
            // Hacer la instancia disponible globalmente para el acceso desde FilePond
            window.photoEditor = this.editor
        }
        this.newsletter = new Newsletter()
        this.page = new Page()
        document.querySelectorAll('.alert').forEach(item => new Alert(item))
        document.querySelectorAll('.change-page').forEach(link => this.onChangeClick(link))
    }

    onChangeClick(_link) {
        _link.addEventListener("click", (e) => {
            const href = _link.getAttribute("href")
            
            // Verificar si hay combinaciones de teclas que indican comportamiento nativo
            const hasModifierKeys = e.ctrlKey || e.metaKey || e.shiftKey || e.altKey
            
            // Si hay teclas modificadoras, permitir el comportamiento nativo
            if (hasModifierKeys) {
                return
            }
            
            e.preventDefault()
            if (window.location.pathname != href) {
                this.preloader.show(href)
            }
        })
    }
}

const _app = new App()